//@flow
export const CREATE_REQUESTED = "memberships/CREATE_REQUESTED";
export const CREATE_COMPLETED = "memberships/CREATE_COMPLETED";
export const CREATE_FAILED = "memberships/CREATE_FAILED";

export const UPDATE_REQUESTED = "memberships/UPDATE_REQUESTED";
export const UPDATE_COMPLETED = "memberships/UPDATE_COMPLETED";
export const UPDATE_FAILED = "memberships/UPDATE_FAILED";

export const DELETE_REQUESTED = "memberships/DELETE_REQUESTED";
export const DELETE_COMPLETED = "memberships/DELETE_COMPLETED";
export const DELETE_FAILED = "memberships/DELETE_FAILED";

export const FETCH_LIST_REQUESTED = "memberships/FETCH_LIST_REQUESTED";
export const FETCH_LIST_COMPLETED = "memberships/FETCH_LIST_COMPLETED";
export const FETCH_LIST_FAILED = "memberships/FETCH_LIST_FAILED";

export const FETCH_DETAILS_REQUESTED = "memberships/FETCH_DETAILS_REQUESTED";
export const FETCH_DETAILS_COMPLETED = "memberships/FETCH_DETAILS_COMPLETED";
export const FETCH_DETAILS_FAILED = "memberships/FETCH_DETAILS_FAILED";

export const RESET_LIST = "memberships/RESET_LIST";

export const RESEND_CONFIRMATION_REQUESTED = "memberships/RESEND_CONFIRMATION_REQUESTED";
export const RESEND_CONFIRMATION_COMPLETED = "memberships/RESEND_CONFIRMATION_COMPLETED";
export const RESEND_CONFIRMATION_FAILED = "memberships/RESEND_CONFIRMATION_FAILED";

export const SYNC_SLACK_REQUESTED = "memberships/SYNC_SLACK_REQUESTED";
export const SYNC_SLACK_COMPLETED = "memberships/SYNC_SLACK_COMPLETED";
export const SYNC_SLACK_FAILED = "memberships/SYNC_SLACK_FAILED";
